import { getAuthHeaders } from "../../auth/services/getAuthHeaders";

export async function fetchDeepgramToken(translatorServiceUrl: string): Promise<string> {
  const authHeaders = await getAuthHeaders();
  const cleanedUrl = translatorServiceUrl.replace(/\/$/, "");
  const res = await fetch(`${cleanedUrl}/deepgram-token`, {
    method: "GET",
    headers: authHeaders,
  });

  if (!res.ok) {
    throw new Error("Failed to get deepgram token");
  }

  const data = await res.json();
  return data.access_token || data.token;
}

interface DeepgramConnectionConfig {
  url: string;
  token: string;
  stream: MediaStream;
  onOpen?: () => void;
  onTranscript?: (transcript: string, detectedLang?: string) => void;
  onError?: (e: Event) => void;
  onClose?: () => void;
}

export interface DeepgramConnection {
  close: () => void;
  recorder: MediaRecorder;
  websocket: WebSocket;
}

export function connectToDeepgram({
  url,
  token,
  stream,
  onOpen,
  onTranscript,
  onError,
  onClose,
}: DeepgramConnectionConfig): DeepgramConnection {
 const ws = new WebSocket(url, ["bearer", token]);
  
  // MediaRecorder for capturing stream chunks
  let recorder: MediaRecorder;

  ws.onopen = () => {
    if (onOpen) onOpen();

    recorder = new MediaRecorder(stream);
    recorder.ondataavailable = (e) => {
      if (e.data.size > 0 && ws.readyState === WebSocket.OPEN) {
        ws.send(e.data);
      }
    };
    recorder.start(250); // Send audio chunks every 250ms
  };

  ws.onmessage = (msg) => {
    try {
      const data = JSON.parse(msg.data);
      if (data.type === "Results") {
        const transcript = data.channel?.alternatives[0]?.transcript;
        if (transcript && transcript.trim().length > 0) {
          const detectedLang = data.channel?.alternatives[0]?.detected_language;
          if (onTranscript) onTranscript(transcript, detectedLang);
        }
      }
    } catch (err) {
      console.error("Deepgram WS parse error:", err);
    }
  };

  ws.onerror = (e) => {
    console.error("Deepgram WS Error", e);
    if (onError) onError(e);
  };

  ws.onclose = () => {
    if (recorder && recorder.state !== "inactive") {
      recorder.stop();
    }
    if (onClose) onClose();
  };

  const close = () => {
    if (recorder && recorder.state !== "inactive") {
      recorder.stop();
    }
    ws.close();
  };

  return { close, websocket: ws, recorder: recorder! };
}
